import React from 'react';
import { ID } from 'app/blocks/common/codes';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';
import PromptAction from 'app/blocks/Prompt/_action/prompt_action';
import './orcid.scss';

type Props = {
    clickHandler: () => void;
    helpSection?: boolean;
    orcid?: string;
    l?: any;
};

export default function Orcid({ clickHandler, helpSection, orcid, l }: Props) {
    return (
        <div className="Orcid Information" data-seleniumid="orcid-information" style={{ marginRight: '2rem' }}>
            <div className="Orcid-Header">
                <div className="Orcid-Title" data-seleniumid="orcid-title-info">
                    {/* Author Services uses your ORCID to link articles to your Author Services profile. */}
                    {l(`${ID.PROFILE_ACCOUNT}.uiLabelMessages.PROFILE_ACCNT_ORCID_TITLE_INFO`)}
                    <a
                        className="Orcid-learnMore"
                        data-seleniumid="orcid-learn-more"
                        href="https://authorservices.wiley.com/author-resources/Journal-Authors/submission-peer-review/orcid.html"
                        rel="noreferrer"
                        style={{ marginLeft: '5px', fontWeight: '600' }}
                        target="_blank"
                    >
                        {' '}
                        {l(`${ID.PROFILE_ACCOUNT}.uiLabelMessages.PROFILE_ACCNT_ORCID_LEARN_MORE`)}
                    </a>
                </div>
                {helpSection && (
                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                    <div
                        className="text-right orcid__question-mark"
                        onClick={event => event.stopPropagation()}
                        role="button"
                        tabIndex={0}
                    >
                        <PromptAction nodeId="orcid" />
                    </div>
                )}
            </div>

            <div className="orcidWidget">
                <div className="orcidWidget-button">
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                    {orcid && (
                        <div>
                            <div
                                className="Orcid_idLink"
                                data-seleniumid="orcid-Id-Link"
                                style={{ width: 'max-content' }}
                            >
                                <SvgIcon.orcidLogoIcon className="orcid__imageIcon" iconTitle="ORCID logo Icon" />
                                <a className="orcid__id" style={{ fontWeight: '600' }}>
                                    https://orcid.org/{orcid}
                                </a>
                            </div>
                        </div>
                    )}
                    {!orcid && (
                        <div
                            className="orcid__button"
                            data-seleniumid="orcid-connection-btn"
                            data-toggle="modal"
                            onClick={clickHandler}
                            onKeyDown={clickHandler}
                            role="button"
                            tabIndex={0}
                        >
                            <SvgIcon.orcidLogoIcon className="orcid__imageIcon" iconTitle="ORCID logo Icon" />
                            <span style={{ color: '#005274', fontWeight: '600' }}>Create or connect your ORCID iD</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
